<template>
  <div class="faq-detail">
    <van-dropdown-menu>
      <van-dropdown-item v-model="parentId" :options="parentOption"></van-dropdown-item>
      <van-dropdown-item v-model="childId" :options="childOption"></van-dropdown-item>
    </van-dropdown-menu>
    <div class="faq-list">
      <van-collapse v-model="activeFaqId" accordion>
        <van-collapse-item v-for="item in filterList" :key="item.id" :title="item.title">
          {{item.content}}
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import {getFaqList, searchWords} from '@/api'
// import {getFaqList} from '@/api'
import {debounce} from '@/utils'

export default {
  name: 'FaqDetail',
  props: {
    store: Object,
    search: String,
  },
  data(){
    return {
      faqList: [],
      parentId: '', //一级分类
      childId: '', //二级分类
      filterStr: '', //实际过滤str
      activeFaqId: 0,
    }
  },
  computed: {
    parentOption() {
      let arr = [{text: this.store.langConfig['AllType'], value: -1}]
      return arr.concat(this.faqList.map(item => ({text:item.name, value: item.id})))
    },
    childOption() {
      let arr = [{text: this.store.langConfig['AllType'], value: -1}]
      this.faqList.forEach(item => {
        if ( this.parentId === item.id || this.parentId === -1) {
          item.children.forEach(child => {
            arr.push({text: child.name, value: child.id})
          })
        }
      })
      return arr
    },
    // 根据str、检索条件 筛选子项
    filterList(){
      let str = this.filterStr
      let pid = this.parentId
      let cid = this.childId

      let arr = []
      this.faqList.forEach(parent => {
        if (pid === -1 || pid === parent.id) {
          parent.children.forEach(child => {
            if (cid === -1 || cid === child.id) {
              child.children.forEach(item => {
                if (item.content.includes(str) || item.title.includes(str)) {
                  arr.push(item)
                }
              })
            }
          })
        }
      })
      return arr
    }
  },
  watch: {
    childOption(v) {
      if (v.length>0) {
        this.childId = v[0].value
      }
    },
    search: {
      immediate: true,
      handler(v) {
        // 查询是否敏感词
        this.searchWords(v)
      }
    },
  },
  created(){
    this.parentId = Number(this.$route.query.id) || -1
    this.getFaqList()
  },
  methods: {
    getFaqList(){
      let url = '/v1/faq/getFAQ/'+ this.store.userInfo.appId + '/'+ this.store.userInfo.language
      getFaqList(url).then(res=>{
        this.faqList = res.data
      })
    },
    // 查询敏感词
    searchWords: debounce(function(str){
      if (str === '') {
        return false
      }
      searchWords({content: str}).then(() => {
        this.filterStr = str
      }, () => {
        this.filterStr = ''
      })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
$mainColor: #599d00;

.faq-detail {
  ::v-deep {
    .van-dropdown-menu__title--active {
      color: $mainColor;
    }
    .van-collapse-item{
      word-break: break-word;
      white-space: normal;
    }
    .van-dropdown-item__option--active {
      color: $mainColor;
    }
    .van-dropdown-item__option--active .van-dropdown-item__icon {
      color: $mainColor;
    }
    .van-collapse-item__content{
      word-break: break-word;
      white-space: normal;
    }
  }
}
</style>